<template>
    <div>
        <div class="toolbar">
            <div class="left-items">
                <a-button
                    class="item"
                    :icon="visible_sidebar?'menu-fold':'menu-unfold'"
                    @click="toggle_sidebar"
                />
                <a-divider type="vertical" class="item" />

                <a-button class="item" icon="icon icon-home" @click="on_reset" />

                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />

                <!-- <a-button class="item" ref="search" icon="search" 
                @click="search()" v-if="!$route.query.in_search"/>-->
                <!-- <a-button class="item" ref="search" icon="search" labelPosition="after"
                                :label="$vueStore.state.common.table.response.total?$vueStore.state.common.table.response.total+'条结果':''"
                primary @click="search()" v-if="$route.query.in_search"/>-->

                <a-button
                    class="item"
                    ref="replay"
                    icon="replay"
                    v-if="$route.query.in_search"
                    primary
                    @click="on_load"
                />
 
                <span class="item selected" v-if="selected_row_keys.length">
                    已选中：
                    <span class="num">{{selected_row_keys.length}}</span>条
                </span>
            </div>

            <div class="right-items">
                <a-input-search
                    placeholder="模糊搜索"
                    enter-button
                    @search="on_search"
                    class="item"
                    v-model="wd"
                />
                <a-button class="item" @click="on_adsearch" icon="icon icon-gaojisousuo1" />
            </div>
        </div>

        <!-- 搜索结果 -->
        <search-field :field="search_field" />

        <!-- 主体表格 -->
        <div class="main">
            <a-table
                :columns="columns"
                :dataSource="data_source"
                rowKey="id"
                :loading="loading"
                :pagination="pagination"
                @change="(e)=>on_pagination_change(e,path)"
                :row-selection="{ selectedRowKeys: selected_row_keys, onChange: on_selection_change }"
                size="middle"
            >
                <!-- 客户信息 -->
                <template slot="customer_render" slot-scope="text, record">
                    <customer-name :record="record" />
                </template>

                <!-- 录入时间 -->
                <template slot="created_render" slot-scope="text, record, index, column">
                    <div class="td-created">
                        <div
                            class="date"
                            v-html="$options.filters['friendly'](moment(text*1000).format('YYYY-MM-DD HH:mm'))"
                        ></div>
                        <div class="user">{{record.author.name}}</div>
                    </div>
                </template>

                <!-- 录入时间 -->
                <template slot="date_render" slot-scope="text, record, index, column">
                    <span
                        v-html="$options.filters['friendly'](moment(text*1000).format('YYYY-MM-DD HH:mm'))"
                    ></span>
                </template>

                 <!-- 地区/渠道 -->
                <template slot="area_render" slot-scope="text, record">
                    <div class="address">
                        <div class="area">
                            {{ record.county
                            ? (record.province ? record.province + "/" : "") +
                            (record.city ? record.city + "/" : "") +
                            record.county
                            : ""}}
                        </div>
                        <div class="full">{{record.full_address}}</div>
                    </div>
                </template>

                <!-- 联系方式 -->
                <template slot="contact_render" slot-scope="text, record, index, column">
                    <table class="contact b-table">
                        <tbody>
                            <tr>
                                <td style="text-align:left" width="20">
                                    <i class="anticon anticon-icon icon-phone"></i>
                                </td>
                                <td @click="do_copy(record.mobile)" class="copy">{{record.mobile}}</td>
                            </tr>
                            <tr v-if="record.qq">
                                <td style="text-align:left">
                                    <i class="anticon anticon-icon icon-QQ"></i>
                                </td>
                                <td class="copy" @click="do_copy(record.qq)">{{record.qq}}</td>
                            </tr>
                            <tr v-if="record.wechat_id">
                                <td style="text-align:left">
                                    <i class="anticon anticon-icon icon-we-chat-s"></i>
                                </td>
                                <td
                                    class="copy"
                                    @click="do_copy(record.wechat_id)"
                                >{{record.wechat_id}}</td>
                            </tr>
                        </tbody>
                    </table>
                </template>

                <!-- 年龄 -->
                <template slot="age_render" slot-scope="text, record">
                    <a-tooltip v-if="text">
                        <template slot="title">出生日期：{{record.birthdate}}</template>
                        {{text}}
                    </a-tooltip>
                </template>

                <!-- 项目以及来源     -->
                <template slot="parent_render" slot-scope="text, record">
                    <div class="parent-render" v-if="text">
                        <div class="parent">{{text.parent.name}}</div>
                        <div class="child"><a-icon type="icon icon-tree" />{{text.name}}</div>
                    </div>
                </template>

                <!-- 跟进动态 -->
                <template slot="content_render" slot-scope="text, record">
                    <revisit-render :record="text" :customer="record" :count="record.content_count"/>
                </template>

                <!-- 操作 -->
                <template slot="action" slot-scope="text, record">
                    <div class="operation">
                        <a-button
                            size="small"
                            @click="on_restore(record)"
                            v-if="permissible.indexOf('member.restore')>-1"
                        >恢复</a-button>

                        <a-button
                            size="small"
                            @click="on_delete(record)"
                            type="danger"
                            style="margin-left: 5px"
                            v-if="permissible.indexOf('member.delete_forever')>-1"
                        >永久删除</a-button>
                    </div>
                </template>
            </a-table>
        </div>

        <!-- 跟进动态 -->
        <modal_followup
            :visible="visible_followup"
            @close="visible_followup=false"
            @load="load"
            :callback="load"
        />

        <!-- 高级搜索 -->
        <advance_search
            :visible="visible_search"
            @close="visible_search=false"
            @load="load"
            :callback="load"
        />

        <!-- 修改密码 -->
        <modal_resetpwd
            :visible="visible_resetpwd"
            @close="visible_resetpwd=false"
            :record="selected_record"
        />
    </div>
</template>

<script>
import advance_search from "./advance_search.vue";
import modal_followup from "../components/modal_followup.vue";
import modal_resetpwd from "../components/modal_resetpwd";
import common_pagination from "../../../mixins/common_pagination.js";

import moment from "moment";
import commonjs from "../mixins/common";

const renderContent = (value, row, index) => {
    const obj = {
        children: value,
        attrs: {}
    };

    if (row.created_at_date) {
        obj.attrs.colSpan = 0;
    }
    return obj;
};

export default {
    mixins: [common_pagination,commonjs],
    components: {
        advance_search,
        modal_followup,
        modal_resetpwd
    },
    data() {
        return {
            sub_title: "已删除",
            path: "/member/deleted",
            visible_folder_list: false,
            loading: false,
            loading_folder: false,
            data_source: [],
            data_folder: [],
            trigger: null,
            restoring: false,
            move_ids: [],
            begin_at: +new Date(),
            wd: null,
            visible_followup: false,
            visible_folder: false,
            visible_create: false,
            visible_search: false,
            visible_resetpwd: false,
            visible_show: false,
            selected_record: null,
            columns: [
                {
                    dataIndex: "created_at_date",
                    title: "客户信息",
                    width: 120,
                    scopedSlots: {
                        customRender: "customer_render"
                    }
                },
                 {
                    dataIndex: "phone",
                    width: 120,
                    title: "联系方式",
                    scopedSlots: {
                        customRender: "contact_render"
                    }
                },
                {
                    dataIndex: "age",
                    title: "年龄",
                    width: 70,
                    scopedSlots: {
                        customRender: "age_render"
                    }
                },
               
                {
                    dataIndex: "last_content",
                    title: "跟进动态",
                    width: 200,
                    scopedSlots: {
                        customRender: "content_render"
                    }
                },
                {
                    dataIndex: "source",
                    title: "来源渠道",
                    width: 100,
                    scopedSlots: {
                        customRender: "parent_render"
                    }
                },
                {
                    dataIndex: "expense",
                    title: "总消费",
                    width: 100,
                    customRender: e => (e > 0 ? e : "")
                },
                {
                    dataIndex: "point",
                    title: "积分",
                    width: 100,
                    customRender: e => (e > 0 ? e : "")
                },
                {
                    dataIndex: "deleted_at",
                    title: "删除时间",
                    width: 120,
                    scopedSlots: {
                        customRender: "date_render"
                    }
                },
                {
                    dataIndex: "created_at",
                    title: "录入时间",
                    width: 150,
                    scopedSlots: {
                        customRender: "created_render"
                    }
                },
                {
                    key: "action",
                    title: "操作",
                    width: 150,
                    align: "center",
                    scopedSlots: {
                        customRender: "action"
                    }
                }
            ]
        };
    },
    watch: {
        $route() {
            this.reset_query();
            this.selected_row_keys = [];
            this.load();
        }
    },
    mounted() {
        this.load();
    },
    created() {
        this.reset_query();

        this.$store.commit("change_state", {
            name: "member_sidebar_selected",
            value: "deleted"
        });
    },
    computed: {
        profile() {
            return this.$store.state.profile;
        }
    },
    methods: {
        moment,
        reset_query() {
            let query = this.$route.query;

            if (Object.prototype.hasOwnProperty.call(query, "wd")) {
                //TODO:判断folder是否存在
                this.wd = query["wd"];
            } else {
                this.wd = null;
            }
        },
        load() {
            this.loading = true;

            let new_query = JSON.parse(JSON.stringify(this.$route.query));
            this.$http
                .get(`/customer/deleted?${this.objectToQuery(new_query)}`)
                .then(res => {
                    if (res.success) {
                        this.data_source = res.data;

                        this.pagination = {
                            pageSize:res.pagination.per_page,
                            total:res.pagination.total,
                            current:res.pagination.current_page
                        }

                        //每次加载完数据后再次统计
                        this.load_stat();
                    }
                })
                .catch(() => {})
                .then(() => {
                    this.loading = false;
                });
        },
        on_delete(record) {
            this.$confirm({
                centered:true,
                title: `是否要永久删除【${record.name}】`,
                content: "请注意，执行删除后将无法无法恢复",
                onOk: () => {
                    return new Promise((resolve, reject) => {
                        this.$http
                            .delete(`customer/force/${record.id}`)
                            .then(res => {
                                if (res.success) {
                                    this.load();
                                } else {
                                    this.$error({
                                        title: "失败",
                                        content: res.message
                                    });
                                }
                            })
                            .catch(() => {})
                            .then(() => {
                                resolve();
                            });
                    });
                }
            });
        },

        on_followup(record) {
            this.visible_followup = true;
        },
        on_adsearch() {
            this.visible_search = true;
        },
        on_restore(record) {
            this.$confirm({
                centered:true,
                content: `是否在已删除中恢复【${record.name}】`,
                onOk: () => {
                    return new Promise((resolve, reject) => {
                        this.$http
                            .post("/customer/restore", {
                                customer_id: record.id
                            })
                            .then(res => {
                                if (res.success) {
                                    this.load();
                                } else {
                                    this.$error({
                                        title: "失败",
                                        content: res.message
                                    });
                                }
                            })
                            .catch(() => {})
                            .then(() => {
                                resolve();
                            });
                    });
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.framework-container {
    .framework-body {
        position: absolute;
        left: 200px;
        right: 0;
        bottom: 0;
        top: 0;
        .main {
            overflow-y: auto;
            position: absolute;
            top: 57px;
            left: 0;
            right: 0;
            bottom: 0;
        }
    }
}
 
.contact {
    width: 110px;
    font-size: 12px;
}

.area {
    .city {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.45);
    }
}
.parent-render {
    .parent {
        font-size: 12px;
        color: #00000080;
    }
    .child {
        font-size: 12px;
    }
}
</style>